import React from 'react';
import CoordinationClient from '@atlassian/jira-engagement/src/ui/coordination-client/index.tsx';
import { STARRED_QUEUE_SPOTLIGHT } from '@atlassian/jira-servicedesk-common/src/constants.tsx';
import { StarredSectionSpotlight } from './spotlight/index.tsx';

type Props = {
	onClose: () => void;
};

const StarredQueueOnboarding = ({ onClose }: Props) => (
	<CoordinationClient messageId={STARRED_QUEUE_SPOTLIGHT} messageType="engagement">
		<StarredSectionSpotlight onClose={onClose} />
	</CoordinationClient>
);

export default StarredQueueOnboarding;
